import { render } from "./Galery.vue?vue&type=template&id=0d5effc6&scoped=true&ts=true"
import script from "./Galery.vue?vue&type=script&lang=ts"
export * from "./Galery.vue?vue&type=script&lang=ts"

import "./Galery.vue?vue&type=style&index=0&id=0d5effc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5effc6"]])

export default __exports__